import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import { themeSpace } from 'styles/themeUtils';

export const CarouselWrapper = styled.div`
  overflow: hidden;
  position: relative;
  max-width: 100vw;
  height: 100%;
`;

CarouselWrapper.displayName = 'CarouselWrapper';

export const CarouselContainer = styled.div`
  display: flex;
  position: relative;
  transition: transform ${({ $transitionDuration }) => $transitionDuration} cubic-bezier(0.23, 1, 0.32, 1);
  transform: translateX(${({ $transform }) => $transform || 0});
  will-change: contents;
  ${({ $shouldExpand }) => $shouldExpand && css`height: 100%;`}
`;

CarouselContainer.displayName = 'CarouselContainer';

CarouselContainer.propTypes = {
  $transform: PropTypes.string.isRequired,
};

export const SwipeableArea = styled.div`
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
`;

SwipeableArea.propTypes = {
  $height: PropTypes.string,
  $width: PropTypes.string,
};

SwipeableArea.displayName = 'SwipeableArea';

export const ControlsContainer = styled.div`
  padding: ${themeSpace(1.5)} 0 ${themeSpace(1)};
`;

ControlsContainer.displayName = 'ControlsContainer';
